<template>
  <div class="row product-content-infowrap" v-if="hasData()">
    <div class="col-sm-6 product-content-infoimagewrap" v-if="product.sharedFile && product.sharedFile[imageIndex]">
       <div class="product-content-infoimage lazy match-row" v-lazy:background-image="baseDomain + shopId + '/files/' + product.sharedFile[imageIndex].id + '.' + encodeURI((product.sharedFile[imageIndex].filename.split('.').pop() ? product.sharedFile[imageIndex].filename.split('.').pop() : 'jpg'))"><img class="js-product-printinfoimage product-content-printinfoimage visible-print-block" :src="baseDomain + shopId + '/files/' + product.sharedFile[imageIndex].id + '.' + encodeURI((product.sharedFile[imageIndex].filename.split('.').pop() ? product.sharedFile[imageIndex].filename.split('.').pop() : 'jpg'))" /></div>
    </div>
    <div class="col-xs-12 col-p-6 product-content-infotext match-row">
      <div class="product-content-infoblock">
        <h3 class="product-content-infotitle js-product-classhereifneedssomethingforbackendpurposes">{{ title }}</h3>
        <div class="product-content-infotable">
          <div class="product-content-inforow" v-for="distance in product.ownDistance">
            <div class="product-content-infolabel" v-html="distance.name"></div>
            <div class="product-content-infovalue" style="white-space: nowrap;" v-html="distance.distance + ' ' + distance.unit"></div>
            <div class="product-content-infovalue" v-html="distance.description"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import VueLazyLoad from 'vue3-lazyload'

// Vue.use(VueLazyLoad)

export default {
  data () {
    return {
      imageIndex: this.$store.state.imageIndex
    }
  },
  props: ['product', 'fields', 'baseDomain', 'shopId', 'hideImage'],
  methods: {
    hasData () {
      return this.product.ownDistance && this.product.ownDistance.length > 0
    }
  },
  computed: {
    title () {
      return this._('Distances')
    }
  },
  created: async function () {
    await this.$store.dispatch('setImageIndex', this.$store.state.imageIndex + 1)
  }
}
</script>
